// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 97,
  argument: "All are again invited to praise the Lord, for the victories of Christ.",
  verses: [
    { n: 1, text: "A psalm for David himself. Sing ye to the Lord a new canticle: because he hath done wonderful things. His right hand hath wrought for him salvation, and his arm is holy." },
    { n: 2, text: "The Lord hath made known his salvation: he hath revealed his justice in the sight of the Gentiles." },
    { n: 3, text: "He hath remembered his mercy and his truth toward the house of Israel. All the ends of the earth have seen the salvation of our God." },
    { n: 4, text: "Sing joyfully to God, all the earth: make melody, rejoice and sing." },
    { n: 5, text: "Sing praise to the Lord on the harp, on the harp, and with the voice of a psalm: 6 with long trumpets, and sound of cornet. Make a joyful noise before the Lord our king: 7 let the sea be moved and the fulness thereof: the world and them that dwell therein." },
    { n: 8, text: "The rivers shall clap their hands, the mountains shall rejoice together 9 at the presence of the Lord: because he cometh to judge the earth. He shall judge the world with justice, and the people with equity." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "David. His name occurs not in Hebrew, though the psalm is worthy of him. (Berthier) — It may refer to the return from captivity, as a figure of the world's redemption. — Things. In rescuing his people from slavery, and in the incarnation. (Calmet) — For him. Or alone. (Menochius) — Christ raised himself by his own power. (Calmet) (Isaias lxii. 5.) — He redeemed mankind for his own glory, sibi.", attribution: "Berthier" }
    ] },
    { verse: 2, notes: [
      { text: "Salvation. Cyrus, or the Messias, whose gospel is preached every where, (Calmet) and who has saved the world.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Israel. The prophets foretold the liberation of the Jew, and of mankind. The blessed Virgin Mary seems to allude to this passage, Luke i. 55. (Calmet) — Some Jews were converted, Romans xi.", attribution: "Worthington" }
    ] },
    { verse: 6, notes: [
      { text: "Cornet. This was a crooked horn; the trumpets were of metal, Numbers x. 2.", attribution: "Calmet" }
    ] },
    { verse: 8, notes: [
      { text: "Hands. These strong oriental expressions hardly suit our language. (Calmet) — They contain a metaphor, and denote the inhabitants of the world, (Haydock) or those rivers, which spring from Jesus Christ, and mountains, which are raised to heaven by his grace, to praise the Redeemer. (St. Augustine) — Then the just are exhorted to lift up their heads.", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
